import * as types from '../mutation-types'

// initial state
const state = {
  id: null,
  name: null,
  logo: null,
  logo_for_white: null,
  primary_color: null,
}

// getters
const getters = {
  isp: state => {
    return {
      id: state.id,
      name: state.name,
      logo: state.logo,
      logo_for_white: state.logo_for_white,
      primary_color: state.primary_color
    }
  }
}

// mutations
const mutations = {

  [types.UPDATE_ISP] (state, isp) {
    state.id = isp.id
    state.name = isp.name
    state.logo = isp.logo
    state.logo_for_white = isp.logo_for_white
    state.primary_color = isp.primary_color
  },

  [types.CLEAR_ISP] (state) {
    state.id = null
    state.name = null
    state.logo = null
    state.logo_for_white = null
    state.primary_color = null
  },

}

export default {
  state,
  getters,
  mutations
}
